/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DateRangeFromJSON, DateRangeToJSON, ResourceTagFromJSON, ResourceTagToJSON, TimeRangeOfDayFromJSON, TimeRangeOfDayToJSON, } from './';
export function CampaignRequestFromJSON(json) {
    return CampaignRequestFromJSONTyped(json, false);
}
export function CampaignRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(ResourceTagFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'duration': !exists(json, 'duration') ? undefined : DateRangeFromJSON(json['duration']),
        'active': json['active'],
        'contents': !exists(json, 'contents') ? undefined : json['contents'],
        'timePlan': !exists(json, 'timePlan') ? undefined : (json['timePlan'].map(TimeRangeOfDayFromJSON)),
        'targetPlayers': !exists(json, 'targetPlayers') ? undefined : json['targetPlayers']
    };
}
export function CampaignRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tags': value.tags === undefined ? undefined : (value.tags.map(ResourceTagToJSON)),
        'name': value.name,
        'duration': DateRangeToJSON(value.duration),
        'active': value.active,
        'contents': value.contents,
        'timePlan': value.timePlan === undefined ? undefined : (value.timePlan.map(TimeRangeOfDayToJSON)),
        'targetPlayers': value.targetPlayers
    };
}
